import Point from 'ol/geom/Point';
import getFeatureCentroid from '@mapsight/lib-ol/feature/getCentroid';
import addPixelPadding from '@mapsight/lib-ol/coordinate/addPixelPadding';

import listStateStore from '../../stores/list-state-store';
import globalActions from '../../actions/global-actions';
import mapActions from '../../actions/map-actions';
import listActions from '../../actions/list-actions';
import tooltipActions from '../../actions/tooltip-actions';
import {isSplitView} from '../../config';

/**
 * @param {import('ol/Map').default} map map
 * @param {any} selectClick selectClick
 * @param {any} dataVectorSource dataVectorSource
 */
export default function (map, selectClick, dataVectorSource) {
	let listState = {};

	listStateStore.listen((nextListState) => {
		const oldListState = listState;
		listState = Object.assign({}, nextListState); // clone

		// when list just expanded / collapsed
		if (oldListState.isExpanded !== listState.isExpanded) {
			// update view padding
			map.getView().set('padding', getPadding(listState.isExpanded));

			// enable / disable interactions
			if (listState.isExpanded && isSplitView) {
				mapActions.disable();
			} else {
				mapActions.enable();
			}
		}
	});

	function getPadding(isExpanded = false) {
		return isExpanded && isSplitView
			? [0, 0, Math.round((window.innerHeight * 5) / 12), 0]
			: [0, 0, 0, 0];
	}

	selectClick.on('select', (evt) => {
		// working as list clickout when list is expanded
		if (listState.isExpanded && isSplitView) {
			selectClick.getFeatures().clear();
			selectClick.getFeatures().extend(evt.deselected);
			listActions.collapse(true);
			return;
		}

		// otherwise select or deselect feature
		const features = evt.selected;
		if (features.length) {
			const feature = features[0];
			const standId = feature.getId();

			process.nextTick(() => {
				tooltipActions.showFeature(false);
				listActions.showDetails(standId);
				globalActions.selectStand(standId);
			});
		} else {
			listActions.showDetails(null);
			globalActions.selectStand(null);
		}
	});

	globalActions.selectStand.listen((standId) => {
		selectClick.getFeatures().clear();

		const feature = standId && dataVectorSource.getFeatureById(standId);
		if (feature) {
			selectClick.getFeatures().push(feature);

			const centroid = getFeatureCentroid(feature);
			const view = map.getView();
			view.fit(new Point(centroid), {
				maxZoom: 22,
				nearest: true,
				duration: 500,
				padding: view.get('padding'),
			});
		}
	});

	function animateMapPadding(isExpanded) {
		const view = map.getView();
		const padding = getPadding(true);

		const center = addPixelPadding(
			view.getResolution(),
			view.getCenter(),
			isExpanded ? padding : padding.map((a) => -a)
		);
		view.animate({
			center: center,
			duration: 500,
		});
	}

	listActions.expand.listen((animateMap = false) => {
		if (animateMap) {
			animateMapPadding(true);
		}
	});
	listActions.collapse.listen((animateMap = false) => {
		if (animateMap) {
			animateMapPadding(false);
		}
	});

	mapActions.zoomOut.listen(() => {
		map.getView().fit(dataVectorSource.getExtent(), {
			padding: getPadding(listState.isExpanded),
			nearest: false,
			duration: 700,
		});
	});

	mapActions.featureHit.listen(() => {
		if (!listState.isExpanded) {
			map.getTarget().classList.add('bssp--feature-is-hit');
		}
	});

	mapActions.featureUnhit.listen(() =>
		map.getTarget().classList.remove('bssp--feature-is-hit')
	);
}
